import React from 'react';

import '../page/inquiry.css';
import {INQUIRY_CATEGORY_MAP} from "../store/inquiryConstants";

class InquiryCreateTable extends React.Component {
    constructor(props) {
        super(props);
        this.textareaRef = React.createRef();

        this.adjustTextareaHeight = this.adjustTextareaHeight.bind(this);
        this.MAX_HEIGHT_PX = 400;
    }

    componentDidUpdate(prevProps) {
        // 부모로부터 받은 content prop이 변경되었을 때만 실행
        if (prevProps.content !== this.props.content) {
            this.adjustTextareaHeight();
        }
    }

    componentDidMount() {
        this.adjustTextareaHeight();
    }

    adjustTextareaHeight = () => {
        const textarea = this.textareaRef.current;
        if (textarea) {
            textarea.style.height = 'auto';

            let newHeight = textarea.scrollHeight;

            if (newHeight > this.MAX_HEIGHT_PX) {
                newHeight = this.MAX_HEIGHT_PX;
            }

            textarea.style.height = `${newHeight}px`;

            textarea.scrollTop = textarea.scrollHeight;
        }
    };

    render() {
        const {
            inquiryType, title, content, attachedFiles, fileInputKey,
            handleChange, handleFileChange, handleFileDelete, handleSubmit, handleFileClick
        } = this.props;

        return (
            <div className="container inquiry-create-container">
                <h1 className="text-center mt-4 mb-5">1:1 문의하기</h1>

                <div className="card p-4">
                    <div className="mb-3 form-row-layout">
                        <label className="form-label required form-label-col">
                            문의유형
                        </label>
                        <div className="form-input-col">
                            <select
                                className="form-select"
                                name="inquiryType"
                                value={inquiryType}
                                onChange={handleChange}
                            >
                                <option value="" disabled>
                                    문의 유형을 선택해주세요.
                                </option>
                                {Object.entries(INQUIRY_CATEGORY_MAP).map(([key, value]) => (
                                    <option key={key} value={key}>
                                        {value}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="mb-3 form-row-layout">
                        <label className="form-label required form-label-col">
                            문의제목
                        </label>
                        <div className="form-input-col">
                            <input
                                type="text"
                                className="form-control"
                                name="title"
                                value={title}
                                onChange={handleChange}
                                placeholder="문의 제목"
                            />
                        </div>
                    </div>

                    <div className="mb-4 form-row-layout">
                        <label className="form-label required form-label-col">
                            문의내용
                        </label>
                        <div className="form-input-col">
                            <textarea
                                ref={this.textareaRef}
                                className="form-control"
                                name="content"
                                value={content}
                                onChange={handleChange}
                                maxLength={500}
                                placeholder="문의 내용을 입력해주세요."
                                style={{ overflowY: 'auto' }}
                            />
                            <div className="d-flex justify-content-end text-muted small mt-1">
                                {content.length}/500
                            </div>
                        </div>
                    </div>

                    <div className="mb-2 form-row-layout">
                        <label className="form-label form-label-col">
                            첨부파일
                        </label>
                        <div className="form-input-col">
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="파일을 업로드 해주세요"
                                    readOnly
                                    value={attachedFiles.length > 0 ? `${attachedFiles.length}개 파일 등록됨` : ''}
                                />
                                <label className="btn btn-primary mb-0" style={{ cursor: 'pointer' }}>
                                    첨부파일
                                    <input
                                        type="file"
                                        key={fileInputKey}
                                        style={{ display: 'none' }}
                                        onChange={handleFileChange}
                                        multiple
                                        accept="image/*, application/pdf, .xlsx, .xls"
                                        disabled={attachedFiles.length >= 5}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className="mb-3 form-row-layout">
                        {/* Label 빈 공간 */}
                        <div className="form-label-col"></div>

                        <div className="form-input-col">
                            <div className="d-flex flex-wrap gap-2 mb-2">
                                {attachedFiles.map(file => (
                                    <div
                                        key={file.id}
                                        className="file-item-badge file-item-fixed"
                                    >
                                        <span
                                            onClick={() => handleFileClick(file)}
                                            className="file-name-link file-name-truncate"
                                        >
                                            {file.name} ({file.size})
                                        </span>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            aria-label="Close"
                                            onClick={() => handleFileDelete(file.id)}
                                        ></button>
                                    </div>
                                ))}
                            </div>

                            <div className="text-muted small">
                                <p className="mb-0">* 사진 및 파일은 최대 <strong style={{color: '#6c757d'}}>5개</strong>까지 등록 가능합니다.</p>
                                <p className="mb-0">* <strong style={{color: '#6c757d'}}>10MB 미만</strong>의 이미지(jpg, jpeg, png) 및 PDF/엑셀 파일만 등록 가능합니다.</p>
                                <p className="mb-0">* 개인정보가 포함된 파일은 등록을 피해주세요.</p>
                            </div>
                        </div>
                    </div>

                    <hr className="my-2" />

                    <div className="mb-2 form-row-layout">
                        <label className="form-label form-label-col">안내 사항</label>
                        <div className="form-input-col">
                            <div className="text-muted small mt-2">
                                <p className="mb-0">* 담당자가 순차적으로 확인 후, 영업일 기준 2~3일 내 답변 드리겠습니다.</p>
                                <p className="mb-0">* 문의에 대한 답변이 등록되면, 가입하신 번호로 알림톡이 발송됩니다.<br />
                                답변 내용은 나의 문의 탭에서 확인해 주세요.</p>
                            </div>
                        </div>
                    </div>

                    {/* 제출 버튼 */}
                    <div className="d-flex justify-content-center pt-3">
                        <button
                            type="button"
                            className="btn btn-primary btn-lg"
                            onClick={handleSubmit}
                            style={{ width: '100%', maxWidth: '300px' }}
                        >
                            제출하기
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default InquiryCreateTable;